var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan2Night = function SvgDAhuSignalFan2Night(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 81,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,71c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S425.5,71,431,71 M431,70c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S437.1,70,431,70L431,70z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.9,74.9c-0.7,1.2-1,2.5-1,3.9c0,4.3,3.4,7.9,7.7,8.1c-1.1,0.6-2.3,1-3.5,1c-3.8,0-6.9-3.1-6.9-6.9 C424.1,78.4,425.6,76.1,427.9,74.9 M430.7,73.2c-0.5,0-0.9,0.1-1.4,0.2c-3.5,0.8-6.1,3.9-6.1,7.7c0,4.3,3.5,7.9,7.9,7.9 c2.2,0,4.2-0.9,5.6-2.4c0.3-0.3,0.6-0.7,0.9-1.1c-0.4,0.2-0.9,0.3-1.3,0.4c-0.4,0.1-0.9,0.1-1.3,0.1c-3.9,0-7.1-3.2-7.1-7.1 c0-1.8,0.7-3.5,1.9-4.8C430,73.7,430.3,73.4,430.7,73.2L430.7,73.2L430.7,73.2z"
  })))));
};
export default SvgDAhuSignalFan2Night;